import * as React from 'react';
import { FC } from 'react';
import { Button, Progress } from 'antd';
import LeftOutlined from '@ant-design/icons/lib/icons/LeftOutlined';
import { Text } from 'components/text/Text';
import styled from 'styled-components';
import { colors } from 'styles/colors';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRequestTutoringFlow,
  getRequestTutoringFlowCurrIdx,
} from 'logic/store/request-tutoring/request-tutoring.selectors';
import { Stack } from 'components/stack/stack';
import { requestTutoringSlice } from 'logic/store/request-tutoring/request-tutoring.slice';

const ProgressBar = styled(Progress)`
  position: absolute;
  top: -33px;
  left: -24px;
  width: calc(100% + 48px);
`;

const BackButton = styled(Button)`
  position: absolute;
  top: -8px;
`;

const Title = styled(Text)`
  color: ${colors.grayText};
  margin-top: 10px;
`;

type Props = {
  title: string;
};

export const RequestStepContainer: FC<Props> = ({ title, children }) => {
  const dispatch = useDispatch();
  const requestTutoringFlowCurrIdx = useSelector(getRequestTutoringFlowCurrIdx);
  const requestTutoringFlow = useSelector(getRequestTutoringFlow);
  const hideBackButton = requestTutoringFlowCurrIdx === 0;

  const onClickPrevious = () =>
    dispatch(requestTutoringSlice.actions.moveToPreviousTutoringRequestFlowStep());

  const getProgressBarFill = () =>
    Math.floor(((requestTutoringFlowCurrIdx + 1) / requestTutoringFlow.length) * 100);

  const renderBackButton = () =>
    !hideBackButton && (
      <BackButton icon={<LeftOutlined />} size="small" type="text" onClick={onClickPrevious} />
    );

  return (
    <Stack gap={1} flow={'row'} style={{ position: 'relative', paddingTop: 24 }}>
      <ProgressBar percent={getProgressBarFill()} strokeColor={colors.primary} showInfo={false} />
      {renderBackButton()}
      <Title size={28}>{title}</Title>
      {children}
    </Stack>
  );
};
